<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
/* ===== NEBULA 设计令牌（与小程序端同源） =====
 * 深空黑 #05070d / 电光蓝 #00d4ff（白底用 cyan-700 #0891b2）
 * 霓虹紫 #a86bff / 荧光绿 #00ff9d / 金属银 #9fb0c8
 * 内容区保持白底保证可读性，深色 HUD 由 Header/Footer 承担 */
:root {
  --nb-bg: #05070d;
  --nb-blue: #00d4ff;
  --nb-blue-ink: #0891b2;
  --nb-purple: #a86bff;
  --nb-green: #00ff9d;
  --nb-silver: #9fb0c8;
  --nb-font-mono: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
}
html, body {
  scroll-behavior: smooth;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
/* 通用卡片 HUD 高亮（各页面 card/item 类名均可叠加） */
.nb-card-hover {
  transition: border-color 0.25s, box-shadow 0.25s, transform 0.25s;
}
.nb-card-hover:hover {
  border-color: rgba(0, 212, 255, 0.55);
  box-shadow: 0 0 18px rgba(0, 212, 255, 0.16), 0 6px 22px rgba(8, 145, 178, 0.1);
}
/* 数据点缀：mono 数字/徽标 */
.nb-mono {
  font-family: var(--nb-font-mono);
  letter-spacing: 1px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue